import axios from "axios";
import { API_HOST } from "../utils/constants";

export default {
    getPipelinesByProject:  (params) => axios.get(`${API_HOST}/api/fpa/v1/projects/${params.id}/pipelines?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}`),
};